import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useOrgStore from '../store/zustand/useOrgStore';

type WebInterfaceFlag = 'hideProducts' | 'hideFeed' | 'disableScheduling';

interface WebInterfaceRouteProps {
  flag: WebInterfaceFlag;
  redirectTo?: string;
}

const WebInterfaceRoute = ({
  flag,
  redirectTo = '/pipeline',
}: WebInterfaceRouteProps) => {
  const orgData = useOrgStore((state) => state.orgData);
  const webInterfaceConfig =
    orgData?.configParms?.features?.webInterface ||
    // @ts-ignore - fallback to global for initial load
    (global as any)?.appSettings?.features?.webInterface ||
    {};

  let isDisabled = webInterfaceConfig[flag] === true;

  // For scheduling, also check features.schedule.enabled
  if (flag === 'disableScheduling' && !isDisabled) {
    const scheduleEnabled =
      orgData?.configParms?.features?.schedule?.enabled ??
      // @ts-ignore - fallback to global for initial load
      (global as any)?.appSettings?.features?.schedule?.enabled ??
      false;
    if (!scheduleEnabled) {
      isDisabled = true;
    }
  }

  if (isDisabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};

export default WebInterfaceRoute;
